import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/deposits'
)({
  component: () => (
    <ComingSoonPage
      title="Deposits"
      description="The deposits console. Coming soon."
    />
  ),
});
